import constants from "constants";
import React, { Component } from "react";
import { connect } from "react-redux";
import { loadPreviousWebinarsSaga } from "../../../../actions/api";
import { loadSponsorsSuggestionsSaga } from "../../../../actions/suggestions";
import { cleanWebinars } from "../../../../actions/webinars";
import PreviousWebinars from "./PreviousWebinars";

const { PREVIOUS_WEBINARS } = constants;

const ALL = "All";

class StudyGroupSuperhostRecordedWebinars extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      group_id: props.params.id,
    };
  }

  componentDidMount() {
    this.props.loadPreviousWebinars(this.state.page, {
      group_id: this.state.group_id,
    });
    this.props.loadSponsorsSuggestions();
  }

  componentWillUnmount() {
    this.props.cleanWebinars();
  }

  sponsorSuggestions = () => {
    const { sponsorOptions } = this.props;
    return [...sponsorOptions, { label: ALL, value: ALL }];
  };

  handleNextPage = () =>
    this.setState({ page: this.state.page + 1 }, () =>
      this.props.loadPreviousWebinars(this.state.page, {
        group_id: this.state.group_id,
      })
    );

  render() {
    return (
      <PreviousWebinars
        webinars={this.props.previous.values}
        nextPage={this.handleNextPage}
        page={this.state.page}
        count={this.props.previous.count}
        sponsor={null}
        sponsors={this.sponsorSuggestions()}
        onFilterChange={() => {}}
        groupId={this.props.params.id}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    previous: state.webinars[PREVIOUS_WEBINARS],
    sponsorOptions: state.suggestions.sponsor.values,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    loadPreviousWebinars: (page, params) =>
      dispatch(loadPreviousWebinarsSaga(page, params)),
    cleanWebinars: () => dispatch(cleanWebinars()),
    loadSponsorsSuggestions: () => dispatch(loadSponsorsSuggestionsSaga()),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StudyGroupSuperhostRecordedWebinars);



// WEBPACK FOOTER //
// ./src/components/StudyGroupSuperhost/Webinars/Recorded/StudyGroupSuperhostRecordedWebinars.jsx